<template>
  <div class="col-md-6">
    <credit-scores :report="report" :showAnchor="false"></credit-scores>
    <credit-history :report="report"></credit-history>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import CreditScores from '@/components/reports/panels/CreditScores';
import CreditHistory from '@/components/reports/panels/CreditHistory';

export default {
  components: {
    CreditScores,
    CreditHistory,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
